/**
 * 產生 UI[CSidebarNavTitle]元件
 * @param {*} roles 權限列表
 * @param {*} name 名稱
 */
function createSidebarNavTitle(roles, name) {
  return ({
    _name: 'CSidebarNavTitle',
    _children: [name],
    roles: roles
  });
}

/**
 * 產生 UI[CSidebarNavItem]元件
 * @param {*} roles 權限列表
 * @param {*} name 名稱
 * @param {*} to router位置
 * @param {*} isIconUse 是否顯示icon
 * @param {*} iconName icon圖片名
 */
function createSidebarNavItem(roles, name, to, isIconUse = false, iconName = undefined) {
  if (isIconUse) {
    return (
      {
        _name: 'CSidebarNavItem',
        name: name,
        to: to,
        icon: iconName,
        roles: roles
      }
    );
  } else {
    return (
      {
        _name: 'CSidebarNavItem',
        name: name,
        to: to,
        roles: roles
      }
    );
  }
}

export default [
  // {
  //   _name: 'CSidebarNavItem',
  //   name: 'Dashboard',
  //   to: '/dashboard',
  //   icon: 'self_dashboard',
  // },
  createSidebarNavTitle(['ROLE_ADMIN','ROLE_PERSON_ADMIN'], '人員管理'),

  createSidebarNavItem(
    ['ROLE_ADMIN','ROLE_PERSON_ADMIN']
    , '生活班管理', '/lifeClass', true, 'cil-bank'),

  createSidebarNavItem(
    ['ROLE_ADMIN','ROLE_PERSON_ADMIN']
    , '人員資料管理', '/person', true, 'cil-people'),

  createSidebarNavTitle(['ROLE_ADMIN', 'ROLE_USER'], '學員管理'),

  createSidebarNavItem(
    ['ROLE_ADMIN', 'ROLE_USER']
    , '學制班管理', '/studyYear', true, 'cil-chart-line'),

  createSidebarNavItem(
    ['ROLE_ADMIN', 'ROLE_USER']
    , '學員資料管理', '/personStudy', true, 'cil-people'),

  createSidebarNavTitle(['ROLE_ADMIN', 'ROLE_USER'], '排名'),

  createSidebarNavItem(
    ['ROLE_ADMIN', 'ROLE_USER']
    , '統計排名', '/orderByYear', true, 'cil-list-numbered'),

  createSidebarNavTitle(['ROLE_ADMIN', 'ROLE_USER'], '書目管理'),

  createSidebarNavItem(
    ['ROLE_ADMIN', 'ROLE_USER']
    , '書目管理', '/book', true, 'cil-book'),   

  createSidebarNavTitle(['ROLE_ADMIN'], '系統管理'),

  createSidebarNavItem(
    ['ROLE_ADMIN']
    , '使用者帳號管理', '/user', true, 'cil-user'), 

  createSidebarNavItem(
    ['ROLE_ADMIN']
    , '系統事件查詢', '/eventsLog', true, 'cil-clock'), 

  // 範例
  // {
  //   _name: 'CSidebarNavTitle',
  //   _children: ['設定'],
  //   roles: ["ROLE_COMPANY_ADMIN_EDITABLE", "ROLE_COMPANY_ADMIN_READABLE", "ROLE_TEST_READABLE", "ROLE_TEST_EDITABLE"]
  // },
  // {
  //   _name: 'CSidebarNavItem',
  //   name: '公司設定',
  //   to: '/setting/companySetting',
  //   icon: 'self_briefcase',
  //   roles: ["ROLE_COMPANY_ADMIN_EDITABLE", "ROLE_COMPANY_ADMIN_READABLE"]
  // },
  // {
  //   _name: 'CSidebarNavItem',
  //   name: '商店設定',
  //   to: '/setting/storeSetting',
  //   icon: 'self_cube',
  //   roles: ["ROLE_TEST_READABLE", "ROLE_TEST_EDITABLE"]
  // },

];